import { Info } from "lucide-react";
import { cn } from "@/lib/utils";

/** Shown when the user has no planner event yet (Profil → Nova proslava). */
export const PLANNER_EVENT_REQUIRED_COPY =
  "Da bi koristili kalkulator, spiskove i zadatke, morate prvo kreirati proslavu.";

export function PlannerEventRequiredNotice({
  className,
  message,
}: {
  className?: string;
  message?: string;
}) {
  return (
    <div
      role="status"
      className={cn(
        "mt-3 rounded-lg border border-amber-500/35 bg-amber-500/10 px-4 py-3 text-sm leading-relaxed text-foreground/95 shadow-sm dark:border-amber-400/25 dark:bg-amber-500/12",
        className
      )}
    >
      <p className="flex gap-3">
        <Info
          className="h-5 w-5 shrink-0 text-amber-700 dark:text-amber-400"
          strokeWidth={2}
          aria-hidden
        />
        <span>{message || PLANNER_EVENT_REQUIRED_COPY}</span>
      </p>
    </div>
  );
}
